import H2 from "@/components/atoms/text/H2";
import Para from "@/components/atoms/text/Para";
import SwiperCore, { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import CardWithImg from "@/components/molecules/CardWithImg";
import { ArrowIcon } from "@/components/atoms/Icons";

SwiperCore.use([Navigation]);

export default function SwiperSection({
  title,
  content,
  swiperCardData,
  className,
}) {
  return (
    <section
      className={`pv-15-d pv-8 bc-blue-light ${className}`}
      id="growth-series"
    >
      <div className="container">
        <div className="fx fx--fe-d fx--c-t fx--c-m fx--sb ps-r mb-8-d mb-7">
          <div className="w-50-d">
            <H2
              className="mb-5 bold"
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <Para
              mobileSize="lg"
              desktopSize="lg"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </div>
          <div className="swiper-button-wrapper ps-r">
            <div className="swiper-button swiper-button-prev">
              <ArrowIcon className="arrow-icon" />
            </div>
            <div className="swiper-button swiper-button-next">
              <ArrowIcon className="arrow-icon" />
            </div>
          </div>
        </div>
        <Swiper
          navigation={{
            prevEl: ".swiper-button-prev",
            nextEl: ".swiper-button-next",
          }}
          spaceBetween={40}
          breakpoints={{
            900: {
              slidesPerView: 3,
            },
            760: {
              slidesPerView: 2.4,
            },
            660: {
              slidesPerView: 2,
            },
            460: {
              slidesPerView: 1.6,
            },
            375: {
              slidesPerView: 1.2,
              spaceBetween: 20,
            },
            280: {
              slidesPerView: 1.15,
            },
          }}
        >
          {swiperCardData.map((slide, idx) => (
            <SwiperSlide key={idx}>
              <CardWithImg
                content={slide.description}
                image={slide.image}
                videoSrc={slide.videoSrc}
                hasPlayBtn
              />
              <div className="swiper-lazy-preloader"></div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <style jsx>{`
        .swiper-container {
          overflow: initial !important;
        }
        .swiper-button-wrapper {
          display: flex;
          gap: 60px;
        }
        @media (max-width: 1199px) {
          .swiper-button-wrapper {
            width: 100%;
            gap: initial;
            justify-content: space-between;
            margin-top: 40px;
          }
        }
      `}</style>
    </section>
  );
}
